import { render, staticRenderFns } from "./WizardCollections.vue?vue&type=template&id=86bfe1a8"
import script from "./WizardCollections.vue?vue&type=script&lang=js"
export * from "./WizardCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports